export default {
    async serverPrefetch() {
        if (!this.listAwards?.length) return;
        const promises = this.listAwards.map((id) => this.$store.dispatch('awards/getAward', id));
        await Promise.all(promises);
    },
};
